import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTextareaDrag: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="textarea-drag"><path d="M14.5 21.5L21.5 14.5" stroke="currentColor" strokeWidth="1.5"/><path d="M6.5 21.5L21.5 6.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconTextareaDrag;
